export const getRandomItem = <Item>(array: Item[]) => {
  return array.length ? array[Math.floor(Math.random() * array.length)] : undefined
}

/// <summary>
/// Does not consider zero (number) or false as empty. Considers isNaN() as empty.
/// </summary>
export function isEmpty(value: unknown): value is undefined | null | '' {
  return value === undefined || value === null || value === '' || (isNumber(value) && isNaN(value))
}

export function eliminateEmpty<Value>(...args: Value[]): Value {
  return args.find(t => !isEmpty(t))!
}

export function isFunction(obj: any): obj is (...args: unknown[]) => unknown {
  return !!(obj && obj.constructor && obj.call && obj.apply)
}

export function isNumber(value: any): value is number {
  return typeof value === 'number'
}

export const getNextItemFromArray = <Item>(array: Item[], item: Item | ((item: Item) => boolean)) => {
  const index = isFunction(item) ? array.findIndex(item) : array.indexOf(item)
  return index >= 0 && index < array.length - 1 ? array[index + 1] : undefined
}

export function enumFromString<T>(enumType: { [index: string]: T }, value: string | undefined): T | undefined {
  return value && ((Object.values(enumType) as unknown) as string[]).includes(value)
    ? ((value as unknown) as T)
    : undefined
}
